const freePlanRequestsPerMonth = Number.parseInt(
  process.env.REACT_APP_FREE_PLAN_REQUESTS_PER_MONTH,
  10
);

if (!Number.isInteger(freePlanRequestsPerMonth) || freePlanRequestsPerMonth <= 0) {
  throw new Error('REACT_APP_FREE_PLAN_REQUESTS_PER_MONTH must be a positive integer');
}

export { freePlanRequestsPerMonth };
